/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Metaindex_Description1Inputs */

const id_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi diskon aktif di egdata.app`)
};

const ms_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layari jualan aktif di egdata.app`)
};

const da_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemse aktive udsalg på egdata.app`)
};

const de_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchstöbern Sie aktive Angebote auf egdata.app`)
};

const en_us2_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse active sales on egdata.app`)
};

const es_es2_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora rebajas activas en egdata.app`)
};

const es_mx2_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora promociones activas en egdata.app`)
};

const fil_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-browse ng mga aktibong sale sa egdata.app`)
};

const fr_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourez les promotions actives sur egdata.app`)
};

const it_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfoglia gli sconti attivi su egdata.app`)
};

const hu_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktív akciók böngészése az egdata.app-on`)
};

const nl_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blader door actieve aanbiedingen op egdata.app`)
};

const no_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bla gjennom aktive salg på egdata.app`)
};

const pl_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądaj aktywne promocje na egdata.app`)
};

const pt_br2_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore promoções ativas no egdata.app`)
};

const pt_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore promoções ativas no egdata.app`)
};

const ro_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorează reducerile active pe egdata.app`)
};

const fi_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selaa aktiivisia alennuksia egdata.appissa`)
};

const sv_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bläddra bland aktiva reor på egdata.app`)
};

const vi_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt các đợt giảm giá đang hoạt động trên egdata.app`)
};

const tr_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app'teki aktif indirimlere göz atın`)
};

const cs_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procházejte aktivní slevy na egdata.app`)
};

const bg_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разгледайте активни промоции на egdata.app`)
};

const ru_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр активных скидок на egdata.app`)
};

const uk_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляньте активні розпродажі на egdata.app`)
};

const ar_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح التخفيضات النشطة على egdata.app`)
};

const hi_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app पर सक्रिय सेल ब्राउज़ करें`)
};

const th_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูลดราคาที่กำลังใช้งานบน egdata.app`)
};

const ja_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app でアクティブなセールを閲覧`)
};

const zh_cn2_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览egdata.app上进行中的促销活动`)
};

const zh_hant1_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瀏覽egdata.app上進行中的促銷活動`)
};

const ko_sales_metaindex_description1 = /** @type {(inputs: Sales_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app에서 진행 중인 할인을 둘러보세요`)
};

/**
* | output |
* | --- |
* | "Browse active sales on egdata.app" |
*
* @param {Sales_Metaindex_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_metaindex_description1 = /** @type {((inputs?: Sales_Metaindex_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Metaindex_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_metaindex_description1(inputs)
	if (locale === "ms") return ms_sales_metaindex_description1(inputs)
	if (locale === "da") return da_sales_metaindex_description1(inputs)
	if (locale === "de") return de_sales_metaindex_description1(inputs)
	if (locale === "en-US") return en_us2_sales_metaindex_description1(inputs)
	if (locale === "es-ES") return es_es2_sales_metaindex_description1(inputs)
	if (locale === "es-MX") return es_mx2_sales_metaindex_description1(inputs)
	if (locale === "fil") return fil_sales_metaindex_description1(inputs)
	if (locale === "fr") return fr_sales_metaindex_description1(inputs)
	if (locale === "it") return it_sales_metaindex_description1(inputs)
	if (locale === "hu") return hu_sales_metaindex_description1(inputs)
	if (locale === "nl") return nl_sales_metaindex_description1(inputs)
	if (locale === "no") return no_sales_metaindex_description1(inputs)
	if (locale === "pl") return pl_sales_metaindex_description1(inputs)
	if (locale === "pt-BR") return pt_br2_sales_metaindex_description1(inputs)
	if (locale === "pt") return pt_sales_metaindex_description1(inputs)
	if (locale === "ro") return ro_sales_metaindex_description1(inputs)
	if (locale === "fi") return fi_sales_metaindex_description1(inputs)
	if (locale === "sv") return sv_sales_metaindex_description1(inputs)
	if (locale === "vi") return vi_sales_metaindex_description1(inputs)
	if (locale === "tr") return tr_sales_metaindex_description1(inputs)
	if (locale === "cs") return cs_sales_metaindex_description1(inputs)
	if (locale === "bg") return bg_sales_metaindex_description1(inputs)
	if (locale === "ru") return ru_sales_metaindex_description1(inputs)
	if (locale === "uk") return uk_sales_metaindex_description1(inputs)
	if (locale === "ar") return ar_sales_metaindex_description1(inputs)
	if (locale === "hi") return hi_sales_metaindex_description1(inputs)
	if (locale === "th") return th_sales_metaindex_description1(inputs)
	if (locale === "ja") return ja_sales_metaindex_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_metaindex_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_metaindex_description1(inputs)
	return ko_sales_metaindex_description1(inputs)
});
export { sales_metaindex_description1 as "sales.metaIndex.description" }